"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgWifiPaidRub = function SvgWifiPaidRub(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wifi-paid-rub_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 9.672c4.832-4.833 12.668-4.833 17.5 0a1.904 1.904 0 1 0 2.692-2.692C17.122.66 6.877.66.558 6.98A1.904 1.904 0 0 0 3.25 9.672Zm3.141 9.463c0 .951.939 1.289 1.23 1.289h.694c0 .927.442 1.33 1.587 1.33s1.504-.444 1.504-1.33h2.185c.293 0 1.04-.332 1.04-1.29 0-.957-.748-1.196-1.04-1.196h-2.185v-.873h2.185c2.463 0 4.048-1.717 4.048-4.138 0-2.484-1.424-4.173-3.766-4.173h-3.88c-1.36 0-1.678.722-1.678 2.005v3.677h-.693c-.302 0-1.26.274-1.26 1.298s.958 1.33 1.26 1.33h.693v.874h-.693c-.292 0-1.23.245-1.23 1.197Zm6.787-4.699h-1.772v-2.909h1.803c1.35 0 1.52.822 1.52 1.446 0 .623-.17 1.463-1.55 1.463Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wifi-paid-rub_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgWifiPaidRub);
var _default = exports["default"] = Memo;